// src/constants/pathUtils.js
import {ASSETS, getPhotoUrl } from './urls';

/**
 * Determines which avatar model to load based on body, gender, and product
 * @param {string} body - The avatar body URL
 * @param {string} avatarGender - The avatar's gender (male/female)
 * @param {string} productGender - The product's gender (erkek/kadın)
 * @returns {string} The URL for the avatar model
 */
export const getAvatarModelPath = (body, avatarGender, productGender) => {
  // Add logging to debug
  console.log('getAvatarModelPath inputs:', { body, avatarGender, productGender });
  
  // First, determine the gender from product (erkek/kadın)
  const gender = (productGender === 'erkek') ? 'erkek' : 'kadın';
  console.log('Determined gender:', gender);
  
  // Normalize avatarGender for comparison (might be 'male'/'female' or 'erkek'/'kadın')
  const normalizedAvatarGender = 
    avatarGender === 'male' || avatarGender === 'erkek' ? 'erkek' : 
    avatarGender === 'female' || avatarGender === 'kadın' ? 'kadın' : null;
  
  console.log('Normalized avatar gender:', normalizedAvatarGender);
  
  // If user has a custom body, use it regardless of gender match
  // OR use it if the gender matches
  if (body && (normalizedAvatarGender === gender || !productGender)) {
    console.log('Using custom body:', body);
    return body;
  }
  
  // Otherwise use default model based on gender
  const modelPath = (gender === 'erkek') ? ASSETS.MODELS.MALE : ASSETS.MODELS.FEMALE;
  console.log('Using default model:', modelPath);
  return modelPath;
};
/**
 * Gets the model URL for a product based on body type
 * @param {Object} product - The product object
 * @param {string} bodyType - The body type (e.g., 'body_1')
 * @returns {string} The URL for the product model
 */
export const getModelUrl = (product, bodyType) => {
  if (!product) return '';
  
  if (bodyType !== 'body_1') {
    const filter = bodyType.split('_')[1];
    const filtered = product.body_models.filter(m => m.body === filter);
    
    if (filtered && filtered.length > 0) {
      return getPhotoUrl(filtered[0].url);
    }
  } 
  
  if (product.models && product.models.length > 0) {
    return getPhotoUrl(product.models[0]);
  }
  
  return '';
};

/**
 * Gets image path for face orientation based on index
 * @param {number} index - The index of the face orientation (0-2)
 * @returns {string} The URL for the face orientation image
 */
export const getFaceOrientationImage = (index) => {
  switch (index) {
    case 0: return ASSETS.IMAGES.FORM.FACE_FRONT;
    case 1: return ASSETS.IMAGES.FORM.FACE_LEFT;
    case 2: return ASSETS.IMAGES.FORM.FACE_RIGHT;
    default: return ASSETS.IMAGES.FORM.FACE_FRONT;
  }
};

/**
 * Gets the image URL for a form step
 * @param {number} step - The step number (1-5)
 * @returns {string} The URL for the step image
 */
export const getFormStepImage = (step) => {
  switch (step) {
    case 1: return ASSETS.IMAGES.FORM.STEP1;
    case 2: return ASSETS.IMAGES.FORM.STEP2;
    case 3: return ASSETS.IMAGES.FORM.STEP3;
    case 4: return ASSETS.IMAGES.FORM.STEP4;
    case 5: return ASSETS.IMAGES.FORM.STEP5;
    default: return ASSETS.IMAGES.FORM.STEP1;
  }
};